import { createFileRoute, redirect } from '@tanstack/react-router'
import { signOut } from '../auth/supabase'

export const Route = createFileRoute('/logout')({
  beforeLoad: async ({ context }) => {
    await signOut()
    context.queryClient.clear()
    throw redirect({ to: '/login', search: { redirect: '/dashboard' } })
  },
})
